import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { SportGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// lottery
const IndexPage = lazy(() => import('src/pages/dashboard/lottery-page'));
const DetailPage = lazy(() => import('src/pages/dashboard/lottery-detail-page'));
// ----------------------------------------------------------------------

export const lotteryRoutes = [
  {
    path: 'lottery',
    element: (
      <SportGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </SportGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: ':tirageId', element: <DetailPage /> },
    ],
  },
];
